// ImageListModal.jsx
import React, { useEffect, useState } from 'react';
import { X, ChevronDown, ChevronUp } from 'lucide-react';
import LoadingAll from '../loadingAll';
import { GET_DATA } from '../../services/API';

export default function ImageListModal({ isOpen, onClose, assistantId, externalReference }) {
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                if (!isOpen) {
                    setImages([]);
                    return;
                }

                setLoading(true);
                const imgs = await GET_DATA(`RequestOpenIA/GetImagesSummaryByFilter?assistantId=${assistantId}&externalReference=${externalReference}&maxItens=60`);

                setImages(imgs.data);
                setLoading(false);

            } catch (error) {
                setLoading(false);
            }
        })();
    }, [isOpen, externalReference]);

    // agrupa as imagens por dia (dd/mm/aaaa)
    const groups = images.reduce((acc, img) => {
        const day = new Date(img.dateCreate).toLocaleDateString();
        if (!acc[day]) acc[day] = [];
        acc[day].push(img);
        return acc;
    }, {});

    // controla qual item está expandido (id único por imagem)
    const [expandedId, setExpandedId] = useState(null);

    const toggleExpand = (id) => {
        setExpandedId(prev => (prev === id ? null : id));
    };

    if (!isOpen) return null;

    return (
        <>
            {
                loading && <LoadingAll />
            }

            <div className="fixed inset-0 z-50 flex items-center justify-center">

                {/* Backdrop */}
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
                    onClick={onClose}
                />

                {/* Painel */}
                <div className="relative z-10 bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto p-6">
                    {/* Header */}
                    <header className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Imagens Enviadas</h2>
                        <button
                            onClick={onClose}
                            className="p-1 hover:bg-gray-200 rounded-full dark:hover:bg-gray-700"
                        >
                            <X className="w-6 h-6 text-gray-600 dark:text-gray-300" />
                        </button>
                    </header>

                    {/* Listagem por grupos */}
                    {Object.entries(groups).map(([day, items]) => (
                        <section key={day} className="mb-6">
                            <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{day}</h3>
                            <ul className="space-y-1">
                                {items.map(item => {
                                    const isOpen = expandedId === item.id;
                                    return (
                                        <li
                                            key={item.id}
                                            className="border border-gray-200 dark:border-gray-700 rounded-md pt-2"
                                        >
                                            <span className="text-sm text-gray-900 dark:text-gray-100 ml-5">Enviado: {new Date(item.dateCreate).toLocaleDateString()} {new Date(item.dateCreate).toLocaleTimeString()}</span>
                                            <button
                                                onClick={() => toggleExpand(item.id)}
                                                className="w-full flex items-center justify-between px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                                            >
                                                {isOpen
                                                    ? <ChevronUp className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                                                    : <ChevronDown className="w-5 h-5 text-gray-600 dark:text-gray-300" />}
                                            </button>
                                            {isOpen && (
                                                <div className="p-4">
                                                    <img
                                                        src={item.urlImage}
                                                        alt={'imagem'}
                                                        className="w-full h-auto rounded-md shadow-sm object-contain"
                                                    />
                                                    <p className='m-10 ml-2 text-justify dark:text-white'>{item.summary}</p>
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </section>
                    ))}

                    {images.length === 0 && (
                        <p className="text-center text-gray-500 dark:text-gray-400">
                            Nenhuma imagem enviada.
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}
